/**
 * Document wire ⇄ domain mappers.
 *
 * The document-service `DocumentResponse` schema is already a flat snake_case
 * object whose field names map 1:1 to the UI camelCase shape, so the generic
 * deep converter handles it without per-field fixups.
 *
 * NOTE: confirm field names against the live document-service contract during
 * real-mode verification and adjust the overrides here only.
 */

import { toCamelDeep } from '@/services/http/caseMap'
import type { Document, DocumentVersion } from '@/types/document.types'

function unwrapList(raw: unknown): Record<string, unknown>[] {
  const arr = Array.isArray(raw) ? raw : ((raw as { items?: unknown[] })?.items ?? [])
  return arr as Record<string, unknown>[]
}

export function mapDocumentFromApi(raw: Record<string, unknown>): Document {
  return toCamelDeep<Document>(raw)
}

export function mapDocumentListFromApi(raw: unknown): Document[] {
  return unwrapList(raw).map(mapDocumentFromApi)
}

export function mapDocumentVersionFromApi(raw: Record<string, unknown>): DocumentVersion {
  return toCamelDeep<DocumentVersion>(raw)
}

export function mapDocumentVersionListFromApi(raw: unknown): DocumentVersion[] {
  // `GET /documents/{id}/versions` returns `{ versions: [...] }`.
  const arr = Array.isArray(raw)
    ? raw
    : ((raw as { versions?: unknown[] })?.versions ?? [])
  return (arr as Record<string, unknown>[]).map(mapDocumentVersionFromApi)
}
